const RANKS = [
  { t: "名场面动图：全员沉默那三秒的循环版", scene: "高能反转", type: "动图", heat: "218.4w", trend: "+42%" },
  { t: "录屏回放：直播当天最吵的一段高能现场", scene: "直播回放", type: "录屏", heat: "187.6w", trend: "+31%" },
  { t: "一句台词切片，网友评论区原地起立", scene: "名场面台词", type: "短视频", heat: "154.2w", trend: "+27%" },
  { t: "神回复压成表情包，聊天里能直接甩", scene: "神回复现场", type: "表情包", heat: "129.5w", trend: "+19%" },
  { t: "翻车记录完整回放，原音不剪更下饭", scene: "翻车记录", type: "录屏", heat: "102.3w", trend: "+15%" },
];

export default function RankBoard() {
  return (
    <section id="rank" className="relative w-full bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-700">
              <i className="ri-fire-fill" />
              DAILY RANK · 今日热榜
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              今天大家都在看的黑料色片段
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              动图、短视频、录屏与表情包按热度排在一起，想找当天的黑料色动态图或视频剪辑，
              照着这份榜单翻就行。
            </p>
          </div>
          <span className="flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-xs text-foreground-600">
            <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" />
            每 10 分钟更新一次热度
          </span>
        </div>

        <div className="mt-9 flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50">
          {RANKS.map((r, i) => (
            <div
              key={r.t}
              className={`group flex cursor-pointer items-center gap-4 px-4 py-4 transition hover:bg-background-100 md:gap-6 md:px-6 ${
                i !== RANKS.length - 1 ? "border-b border-background-200" : ""
              }`}
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-heading text-base font-black ${
                  i === 0
                    ? "bg-accent-500 text-background-50"
                    : i === 1
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-950 md:text-base">{r.t}</p>
                <p className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">{r.scene}</span>
                  <span className="rounded bg-background-100 px-1.5 py-0.5 text-[11px] text-foreground-600">{r.type}</span>
                </p>
              </div>
              <div className="flex shrink-0 items-center gap-3 md:gap-5">
                <span className="hidden items-center gap-1 text-sm font-semibold text-foreground-700 sm:flex">
                  <i className="ri-fire-fill text-primary-600" />
                  {r.heat}
                </span>
                <span className="flex items-center gap-0.5 rounded-full bg-primary-50 px-2 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-arrow-up-line" />
                  {r.trend}
                </span>
                <span className="hidden h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-500 transition group-hover:bg-primary-500 group-hover:text-background-50 md:flex">
                  <i className="ri-play-fill text-sm" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}